export default (() => {
  if (window.jQuery) {
    $(document).on('added_to_cart', function () {
      updateCartData('add');
      if (theme_object.messages.product_added_to_cart) {
        var holder = jQuery('.cart-product-added');
        holder.fadeIn(200, function () {
          $(this).addClass('overlay');
          $(this).html('<div class="message-holder"><span>' + theme_object.messages.product_added_to_cart + '</span></div>');
        });
        holder.delay(3000).fadeOut(200, function () {
          $(this).removeClass('overlay');
          $(this).html('');
        });
      }
    });

    // Listen for when a product is removed from the cart
    $(document).on('removed_from_cart', function () {
      updateCartData('remove');
    });

    // Function to update the cart data via AJAX
    function updateCartData() {
      $.ajax({
        url: wc_add_to_cart_params.ajax_url,
        // WooCommerce provides this variable
        type: 'GET',
        data: {
          action: 'lef_update_cart_data' // The action that WordPress will handle
        },
        success: function (response) {
          if (response.success) {
            // Update the cart item count
            const itemCount = response.data.item_count;
            $('#menu-item-cart .cart-items-count').text(itemCount);
            if (itemCount > 0) {
              $('#menu-item-cart .cart-items-count').removeClass('empty');
            } else {
              $('#menu-item-cart .cart-items-count').addClass('empty');
            }
          } else {
            console.log('Failed to update cart data');
          }
        },
        error: function () {
          console.log('Error fetching cart data');
        }
      });
    }
  } else {
    // jQuery is not available
  }
});